import { DateTimeUtils } from "dyl-components";

export default class QueryParamsUtils {
    static isUsingFilters = ({ params, isUsingPage }) => {
        const query = new URLSearchParams(params);
        const queryKeys = Array.from(query.keys());
        if (isUsingPage && queryKeys) {
            return !(queryKeys.length < 2 && queryKeys[0] === 'page');
        }
        return false;
    }

    static getDayTimestampsParameter = (userAuthTimezone, startParam='start', endParam='end') => {
        const { start, end } = DateTimeUtils.getDateRange('today', DateTimeUtils.getTimezoneCurrentDay(userAuthTimezone), DateTimeUtils.DATE_FORMAT, 'day', true, userAuthTimezone);
        return `${startParam}=${start}&${endParam}=${end}`;
    }
}
